import React, { useEffect, useState } from "react";
import "../../styles/w_2484/w-2484Style.css";
import "../../styles/ss4_form.css";
import SS4Page from "./SS4Page";
import SS4Page2 from "./SS4Page2";

interface SS4FormProps {
  formValue?: any;
  setFormValues?: (values: any) => void;
  loading?: boolean;
  isSubmit?: boolean;
}

/**
 * Hosts the two SS-4 sheets.
 *
 * The form body is SS4Page / SS4Page2 — an exact replica of the official
 * Form SS-4 (Rev. December 2025), laid out at the coordinates measured out of
 * fss4.pdf. The props and the shape of the data written back are unchanged
 * from the previous flow-based build, so SS4Form.tsx needs no changes.
 *
 * Each #pdf-content-page-* section is exactly one US Letter sheet, so the
 * capture maps onto a PDF page 1:1 with no slicing.
 */
const SS4Header = ({
  formValue,
  setFormValues,
  loading,
  isSubmit,
}: SS4FormProps) => {
  const [formData, setFormData] = useState<any>(formValue || {});

  useEffect(() => {
    if (formValue) setFormData(formValue);
  }, [formValue]);

  const handleChange = (patch: any) => {
    setFormData((prev: any) => {
      const next = { ...prev, ...patch };
      setFormValues?.(next);
      return next;
    });
  };

  return (
    <div id="pdf-content" className="ss4-screen">
      <div id="pdf-content-page-1" className="ss4-page">
        <SS4Page value={formData} onChange={handleChange} disabled={loading} />
      </div>
      <div id="pdf-content-page-2" className="ss4-page">
        <SS4Page2 />
      </div>
    </div>
  );
};

export default SS4Header;
